import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import Button from '@/shared/Button'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

const mapStateToProps = ({ loading }) => ({
  isLoading:
    loading['smsTemplate/getSmsTemplateHtml'] ||
    loading['smsTemplate/getSmsTemplateHisHtml'] ||
    loading['smsTemplate/getSmsTemplateById'],
})

const SmsTemplatePreviewDialog = ({ dispatch, history, smsTempId, title, isLoading, ...props }) => {
  const [data, setData] = useState()

  const [htmlContent, setHtmlContent] = useState()
  const { onClose } = props

  const { t } = useTranslation()

  useEffect(() => {
    if (smsTempId) {
      dispatch({
        type: history ? 'smsTemplate/getSmsTemplateHisHtml' : 'smsTemplate/getSmsTemplateHtml',
        payload: { smsTempId },
        successCallback: response => {
          const parser = new DOMParser()
          const replaceContent = (response.content || response).replaceAll('\n', '<br>')
          const doc = parser.parseFromString(replaceContent, 'text/html')

          const anchors = doc.getElementsByTagName('a')

          for (let i = 0; i < anchors.length; i += 1) {
            anchors[i].setAttribute('target', '_blank')
          }

          setHtmlContent(doc.documentElement.innerHTML)
        },
      })

      dispatch({
        type: history ? 'smsTemplate/getSmsTemplateHisById' : 'smsTemplate/getSmsTemplateById',
        payload: { smsTempId },
        successCallback: response => {
          const { senderPhone, content } = response

          setData({
            senderPhone,
            content,
          })
        },
      })
    }
  }, [dispatch, smsTempId, history])

  return (
    <Dialog {...props} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      {isLoading && (
        <Grid item display="flex" justifyContent="center" alignItems="center" xs={12} my={2}>
          <CircularProgress />
        </Grid>
      )}
      {!isLoading && (
        <DialogContent>
          <Box sx={{ backgroundColor: '#ecf1f2', padding: 2, fontSize: 14 }}>
            <Grid item container spacing={1}>
              <Grid item xs={2}>
                <Typography variant="subtitle2" sx={{ color: '#555' }}>
                  {t('general.sender')}
                </Typography>
              </Grid>
              <Grid item>
                <Box display="flex" alignItems="flex-end">
                  {data?.senderPhone}
                </Box>
              </Grid>
            </Grid>
          </Box>
          <div
            style={{
              maxHeight: 300,
              marginTop: 20,
              overflowX: 'hidden',
              overflowY: 'auto',
              wordBreak: 'break-all',
            }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </DialogContent>
      )}
      <DialogActions>
        <Button color="neutral" onClick={() => onClose()}>
          {t('general.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(mapStateToProps)(SmsTemplatePreviewDialog)
